const n = (r, e) => r.includes(e);
export {
  n as arrayIncludes
};
